export default {
  app: {
    searchNotData: '暂无搜索结果',
    toSearch: '确认',
    toNavigate: '切换',
  },
  countdown: {
    normalText: '获取验证码',
    sendText: '{0}秒后重新获取',
  },
  cropper: {
    selectImage: '选择图片',
    uploadSuccess: '上传成功',
    modalTitle: '头像上传',
    okText: '确认并上传',
    btn_reset: '重置',
    btn_rotate_left: '逆时针旋转',
    btn_rotate_right: '顺时针旋转',
    btn_scale_x: '水平翻转',
    btn_scale_y: '垂直翻转',
    btn_zoom_in: '放大',
    btn_zoom_out: '缩小',
    preview: '预览',
  },
  drawer: {
    loadingText: '加载中...',
    cancelText: '关闭',
    okText: '确认',
  },
  excel: {
    exportModalTitle: '导出数据',
    fileType: '文件类型',
    fileName: '文件名',
  },
  form: {
    putAway: '收起',
    unfold: '展开',

    maxTip: '字符数应小于{0}位',

    apiSelectNotFound: '请等待数据加载完成...',
  },
  icon: {
    placeholder: '点击选择图标',
    search: '搜索图标',
    copy: '复制图标成功!',
  },
  menu: {
    search: '菜单搜索',
  },
  modal: {
    cancelText: '关闭',
    okText: '确认',
    close: '关闭',
    maximize: '最大化',
    restore: '还原',
  },
  table: {
    settingDens: '密度',
    settingDensDefault: '默认',
    settingDensMiddle: '中等',
    settingDensSmall: '紧凑',
    settingColumn: '列设置',
    settingColumnShow: '列展示',
    settingIndexColumnShow: '序号列',
    settingSelectColumnShow: '勾选列',
    settingFixedLeft: '固定到左侧',
    settingFixedRight: '固定到右侧',
    settingFullScreen: '全屏',

    index: '序号',

    total: '共 {total} 条数据',
  },
  time: {
    before: '前',
    after: '后',
    just: '刚刚',
    seconds: '秒',
    minutes: '分钟',
    hours: '小时',
    days: '天',
  },
  tree: {
    selectAll: '选择全部',
    unSelectAll: '取消选择',
    expandAll: '展开全部',
    unExpandAll: '折叠全部',
    checkStrictly: '层级关联',
    checkUnStrictly: '层级独立',
  },
  upload: {
    save: '保存',
    upload: '上传',
    imgUpload: '图片上传',
    uploaded: '已上传',

    operating: '操作',
    del: '删除',
    download: '下载',
    saveWarn: '请等待文件上传后，保存!',
    saveError: '没有上传成功的文件，无法保存!',

    preview: '预览',
    choose: '选择文件',

    accept: '支持{0}格式',
    acceptUpload: '只能上传{0}格式文件',
    maxSize: '单个文件不超过{0}MB',
    maxSizeMultiple: '只能上传不超过{0}MB的文件!',
    maxNumber: '最多只能上传{0}个文件',

    legend: '略缩图',
    fileName: '文件名',
    fileSize: '文件大小',
    fileStatue: '状态',

    startUpload: '开始上传',
    uploadSuccess: '上传成功',
    uploadError: '上传失败',
    uploading: '上传中',
    uploadWait: '请等待文件上传结束后操作',
    reUploadFailed: '重新上传失败文件',
  },
  verify: {
    error: '验证失败！',
    time: '验证校验成功,耗时{time}秒！',

    redoTip: '点击图片可刷新',

    dragText: '请按住滑块拖动',
    successText: '验证通过',
  },
};
